import { Box } from "@chakra-ui/react";

export default () => (
  <Box h="4px" w="100%">
    <Box  height="100%" bg="#F2F2F2" borderRadius="5px" className="loading-bar"></Box>
  </Box>
);
